import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Leaf, Trophy } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { POLICIES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];
const ICONS = [GraduationCap, Leaf, Trophy];

const Policies = () => {
  const { lang, t } = useLang();
  return (
    <section data-testid="policies-section" className="relative bg-forest-deep text-cream py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="max-w-3xl mb-16">
          <SectionLabel dark>{t("policies.label")}</SectionLabel>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl mt-6">
              {t("policies.title")}
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {POLICIES.map((p, i) => {
            const Icon = ICONS[i] || Trophy;
            return (
              <motion.div
                key={p.num}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, ease: EASE, delay: i * 0.1 }}
                className="bg-forest-surface rounded-tr-[2rem] rounded-bl-[2rem] p-8 lg:p-10 flex flex-col"
                data-testid={`policy-${p.num}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <Icon className="text-gold" size={28} />
                  <span className="font-display text-4xl font-light text-cream/25">{p.num}</span>
                </div>
                <h3 className="font-display text-2xl font-medium leading-snug">{p[lang].title}</h3>
                <p className="text-cream/70 font-light leading-relaxed mt-4 text-sm">{p[lang].text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Policies;
